export default __webpack_public_path__ + "static/media/Delicard-EMP-banner-summer.c1f639bb.jpg";